var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReact(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface103676415"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#61dafb",
      fillOpacity: 1
    },
    d: "M 24 34 C 11.101562 34 1 29.601562 1 24 C 1 18.398438 11.101562 14 24 14 C 36.898438 14 47 18.398438 47 24 C 47 29.601562 36.898438 34 24 34 Z M 24 16 C 11.398438 16 3 20.101562 3 24 C 3 27.898438 11.398438 32 24 32 C 36.601562 32 45 27.898438 45 24 C 45 20.101562 36.601562 16 24 16 Z M 24 16"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#61dafb",
      fillOpacity: 1
    },
    d: "M 15.101562 44.601562 C 14.101562 44.601562 13.300781 44.398438 12.5 43.898438 C 7.601562 41.101562 8.898438 30.199219 15.300781 19 C 18.300781 13.800781 22 9.398438 25.601562 6.601562 C 29.5 3.601562 33 2.699219 35.398438 4.101562 C 37.898438 5.5 38.800781 9 38.199219 13.898438 C 37.601562 18.5 35.601562 23.898438 32.601562 29.101562 C 29.601562 34.300781 25.898438 38.699219 22.300781 41.5 C 19.699219 43.5 17.199219 44.601562 15.101562 44.601562 Z M 32.898438 5.398438 C 31.300781 5.398438 29.199219 6.300781 26.898438 8.101562 C 23.5 10.800781 20 15 17.101562 20 C 10.800781 30.898438 10.199219 40.300781 13.5 42.199219 C 15.199219 43.199219 18 42.300781 21.101562 39.898438 C 24.5 37.199219 28 33 30.898438 28 C 33.800781 23 35.699219 17.898438 36.300781 13.601562 C 36.800781 9.601562 36.199219 6.800781 34.5 5.800781 C 34 5.601562 33.5 5.398438 32.898438 5.398438 Z M 32.898438 5.398438"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#61dafb",
      fillOpacity: 1
    },
    d: "M 33 44.601562 C 28 44.601562 20.800781 38.5 15.398438 29 C 8.898438 17.800781 7.601562 6.898438 12.5 4.101562 C 17.398438 1.300781 26.199219 7.800781 32.699219 19 C 35.699219 24.199219 37.699219 29.601562 38.300781 34.199219 C 39 39.101562 38 42.5 35.5 44 C 34.699219 44.398438 33.898438 44.601562 33 44.601562 Z M 13.5 5.800781 C 10.199219 7.699219 10.800781 17.101562 17.101562 28 C 23.398438 38.898438 31.199219 44.101562 34.5 42.199219 C 36.199219 41.199219 36.800781 38.398438 36.300781 34.398438 C 35.699219 30.101562 33.800781 25 30.898438 20 C 24.601562 9.101562 16.800781 3.898438 13.5 5.800781 Z M 13.5 5.800781"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#61dafb",
      fillOpacity: 1
    },
    d: "M 28 24 C 28 26.210938 26.210938 28 24 28 C 21.789062 28 20 26.210938 20 24 C 20 21.789062 21.789062 20 24 20 C 26.210938 20 28 21.789062 28 24 Z M 28 24"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReact);
export default __webpack_public_path__ + "static/media/react.f9087028a50d49beadfdeab4c6ab8341.svg";
export { ForwardRef as ReactComponent };